import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@remote/assets/img/logo.svg';
import _imports_1 from '../assets/img/speedup.svg';
const _withScopeId = n => (_pushScopeId("data-v-60ee749a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "header-title"
};
const _hoisted_2 = {
  key: 2,
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12",
  viewBox: "0 0 12 12"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M6.92186 9.69375C6.44211 10.2695 5.55789 10.2695 5.07813 9.69375L1.64018 5.56821C0.988856 4.78661 1.54464 3.59999 2.56205 3.59999L9.43795 3.59999C10.4554 3.59999 11.0111 4.78662 10.3598 5.56821L6.92186 9.69375Z"
}, null, -1));
const _hoisted_4 = [_hoisted_3];
const _hoisted_5 = {
  key: 1,
  class: "file-tab-vip-speed"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "file-tab-speedIcon",
  draggable: "false"
}, null, -1));
const _hoisted_7 = {
  class: "file-tab-vipword"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_IconHome = _resolveComponent("IconHome");
  return _openBlock(), _createElementBlock("header", {
    class: _normalizeClass(["header", {
      'is-disabled': _ctx.disabled,
      'is-vip': _ctx.isVip,
      'android-padding': _ctx.isAndroid,
      'ios-padding': _ctx.isUseIOSHeader,
      'harmony-padding': _ctx.isHarmonyNative
    }])
  }, [_createElementVNode("div", _hoisted_1, [_ctx.isNative ? (_openBlock(), _createBlock(_component_IconHome, {
    key: 0,
    width: "36",
    height: "36",
    onClick: _ctx.callAppHome
  }, null, 8, ["onClick"])) : _createCommentVNode("", true), !_ctx.isNative ? (_openBlock(), _createElementBlock("img", {
    key: 1,
    class: "header-logo",
    onClick: _cache[0] || (_cache[0] =
    //@ts-ignore
    (...args) => _ctx.callAppHome && _ctx.callAppHome(...args)),
    src: _imports_0,
    alt: "logo",
    draggable: "false"
  })) : _createCommentVNode("", true), _createElementVNode("div", {
    class: "header-home",
    onClick: _cache[1] || (_cache[1] =
    //@ts-ignore
    (...args) => _ctx.onOpenDeviceList && _ctx.onOpenDeviceList(...args))
  }, _toDisplayString(_ctx.currentDeviceName), 1), _ctx.isLogin ? (_openBlock(), _createElementBlock("svg", _hoisted_2, _hoisted_4)) : _createCommentVNode("", true)]), _ctx.showSpeedUp ? (_openBlock(), _createElementBlock("a", {
    key: 0,
    href: "javascript:;",
    class: "speed-btn",
    onClick: _cache[2] || (_cache[2] =
    //@ts-ignore
    (...args) => _ctx.goVip && _ctx.goVip(...args))
  }, "会员加速")) : _createCommentVNode("", true), _ctx.showVipSpeedUp ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_hoisted_6, _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.isSuperVip ? '超级会员' : '会员') + "特权加速中", 1)])) : _createCommentVNode("", true)], 2);
}